import { render, staticRenderFns } from "./cardCastingCall.vue?vue&type=template&id=b653dac6&scoped=true&"
import script from "./cardCastingCall.vue?vue&type=script&lang=js&"
export * from "./cardCastingCall.vue?vue&type=script&lang=js&"
import style0 from "./cardCastingCall.vue?vue&type=style&index=0&id=b653dac6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b653dac6",
  null
  
)

export default component.exports